<template>
<div class="page-container">
    <el-container>
    <el-header>
      <Myheader pageType="subpage" :selectIndex="selectIndex" v-on:goHome="goHome"></Myheader>
    </el-header>
    <div class="banner">
      <img src="../../../../static/images/news-dtl-banner.png"  style="width: 100%;">
      <p class="type-title">{{ tyleTitle }}</p>
    </div>
    <el-main>
      <div style="margin-top:40px;">
        <div v-if="newsDtl !=null">
            <div class="news-title" :class="{'mobile-width':mobilePage}" v-html="newsDtl.NTITLE"></div>
            <div class="news-date" :class="{'mobile-width':mobilePage}">发布日期:{{ formatDate(newsDtl.NDATETIME) }}</div>
            <div class="news-content" :class="{'mobile-width':mobilePage}" v-html="newsDtl.NCONTENT"></div>
        </div>
        <div class="none-data" :class="{'mobile-width':mobilePage}" v-else>暂无数据</div>
    </div>
    </el-main>
    <Mybottom/>
    </el-container>
</div>
</template>

<script>
import Mybottom from '@/components/pageBottom/bottom.vue'
import Myheader from '@/components/pageHeader/header.vue'
import { findNewsDtl } from '@/api/api.js'
import { getSign } from '@/utils/md5.js'
import { Message } from 'element-ui'
export default {
  name: 'index',
  data () {
    return {
      mobilePage: false,
      selectIndex: 3,
      id: null,
      tyleTitle: '新闻动态',
      logoUrl: require('../../../../static/images/logo.png'),
      companyQr: require('../../../../static/images/company-qr.png'),
      wechatQr: require('../../../../static/images/wechat-qr.png'),
      newsDtl: null
    }
  },
  components: {
    Mybottom,
    Myheader
  },
  mounted () {
    if (navigator.userAgent.match(/mobile/i)) {
      this.mobilePage = true
    }
  },
  created () {
    const typeDes = this.$route.query.type
    this.id = this.$route.query.id
    if (typeDes === '0') {
      this.tyleTitle = '公司新闻'
    } else {
      this.tyleTitle = '行业动态'
    }
    this.initDtl()
  },
  methods: {
    goHome (partId) {
      this.$router.push({path: '/', query: {partId: partId}})
    },
    initDtl () {
      this.loading = true
      const jsonData = "{'id':" + this.id + ', "CnOrJpFlg":"CN"}'
      const sign = getSign('getNewsDtl')
      this.$http({
        url: findNewsDtl + '?Operation=getNewsDtl&jsonData=' + jsonData + '&sign=' + sign,
        method: 'get'
      }).then(({ data }) => {
        // 处理
        this.loading = false
        if (data.Code === 200) {
          this.newsDtl = data.Data
        } else {
          if (!data.Msg) {
            data.Msg = '获取详细失败'
          }
          Message.error(data.Msg)
        }
      })
    },
    formatDate (date) {
      let thisDate = new Date(date)
      let yy = thisDate.getFullYear()
      let MM = (thisDate.getMonth() + 1) < 10 ? '0' + (thisDate.getMonth() + 1) : (thisDate.getMonth() + 1)
      let dd = thisDate.getDate() < 10 ? '0' + thisDate.getDate() : thisDate.getDate()
      return yy + '-' + MM + '-' + dd
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mobile-width {
    width: 95% !important;
  }
.type-title{
  position: absolute;
  left: 19%;
  top: 70px;
  font-size: 58px;
  color: white;
  font-weight: 600;
}
.el-header{
    height: 70px !important;
    padding: 0px;
  }
  .page-header .logo{
    height: 100%;
  }
  .page-header .menu{
    height: 100%;
  }
  .logo .logo-img{
    text-align: center;
    padding: 10px 0px;
  }
  .tabBox{
    width: 100%;
    height: 70px;
    background-color: #fff;
    cursor: pointer;
  }
  .content{
    width: 65%;
    margin: auto;
    position: relative;
    min-width:1082px
  }
  .pageBox .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    opacity: 1;
    color: black;
  }
  .tabContainer{
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: space-between;
  }
  .topTab{
    width: 62%;
    justify-content: flex-end;
  }
  .topTab li{
    width: 16.7%;
    cursor: pointer;
    text-align: center;
  }
  .topTab li span{
    color: #4E4E4E;
    height: 80px;
    font-size: 16px;
  }
  .topTab li.active span{
    color: #0065F3;
    font-weight: 700;
    /* border-bottom: 3px solid #0065F3; */
    display: inline-block;
    line-height:80px;
  }
  .logo .logo-img{
    text-align: center;
    padding: 15px 0px;
  }
  .menu-items{
    width: 60%;
    line-height: 50px;
  }
  .menu-items .menu-item{
    padding-top: 5px;
    font-size: 16px !important;
    color: grey;
    cursor: pointer;
  }
  .menu-item-select{
    color: #0451db !important;
    font-weight: 700;
  }
  .news-title{
    font-size: 28px;
    color: black;
    text-align: center;
    width: 63%;
    margin: auto;
  }
  .news-date{
    font-size: 14px;
    padding: 10px;
  }
  .news-content{
    font-size: 20px;
    width: 63%;
    margin: auto;
    text-align: left;
    padding: 0px 0px 20px 0px;
    min-height: 320px;
  }
  .foot-part{
    height: 326px !important;
    line-height: 40px !important;
    background-image: url('../../../../static/images/foot-bg.png');
    background-size: 100% 100%;
    padding: 0px;
  }
  .foot-part .foot-part-container{
    width: 65%;
    margin: auto;
  }
  .foot-part .foot-title{
    text-align: left;
    width: 100%;
    font-size: 30px;
    color: black;
    font-weight: 700;
    padding-top: 60px;
    margin-bottom: 10px;
  }
  .foot-part  .foot-title-desc{
    font-size: 20px;
    text-align: left;
  }
  .foot-part .about-tell{
      font-size: 30px;
      text-align: left;
      margin-top: 18px;
      height: 50px;
      line-height: 50px;
      position: relative;
  }
  .foot-part .tell-tag{
    background-color: #0550DC;
    color: white;
    opacity: 0.9;
    padding: 3px 10px;
    font-size: 20px;
    letter-spacing: 4px;
    height: 40px;
    line-height: 40px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    width: 115px;
    bottom: 0;
    text-align: center;
  }
  .foot-part  .tell-phone{
    height: 50px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 145px;
    width: 200px;
    bottom: 0;
    font-size: 40px;
    color: black;
    font-weight: 700;
  }
  .foot-part  .company-name{
    text-align: left;
    font-size: 16px;
    color: #626A7E;
    line-height: 15px;
  }
  .foot-part  .company-address{
    text-align: left;
    font-size: 16px;
    color: #626A7E;
  }
  .foot-part  .qr-items-title{
    font-size: 24px;
    color: black;
    font-weight: 700;
    margin-top: 75px;
    margin-bottom: 15px;
  }
  .foot-part  .company-qr{
    width: 103px;
    height: 103px;
  }
  .foot-part  .wechat-qr{
    width: 103px;
    height: 103px;
  }
  .foot-part .company-qr-remark{
    line-height: 20px;
    font-size: 14px;
  }
  .foot-part .wechat-qr-remark{
    line-height: 20px;
    font-size: 14px;
  }
  .none-data{
    width: 100%;
    height: 430px;
    font-size: 32px;
    line-height: 430px;
    opacity: 0.8;
  }
</style>



// WEBPACK FOOTER //
// src/views/news/newsDetail/detail.vue